import { apiRequest } from "../../index";
import config from "../../../../config";

const { VCHAT_API } = config;
const api = `${VCHAT_API}/images`;

export async function getImages({ id, classroomId }) {
  try {
    const response = await apiRequest(
      `${api}/${id}?classroomId=${classroomId}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getBuffer() {
  try {
    const response = await apiRequest(`${api}/getbuff`, "GET");
    return response;
  } catch (err) {
    throw err;
  }
}

export async function getImage({ id, created, classroomId }) {
  try {
    const response = await apiRequest(
      `${api}/${id}/${created}?classroomId=${classroomId}`,
      "GET",
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function createImage(body, classroomId) {
  try {
    const response = await apiRequest(
      `${api}/?classroomId=${classroomId}`,
      "POST",
      body,
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateImage(body) {
  const { userId, customer, imageName } = body;
  try {
    const response = await apiRequest(
      `${api}/${userId}/${customer}/${imageName}`,
      "PUT",
      body,
    );
    return response;
  } catch (err) {
    throw err;
  }
}

export async function deleteImage(body) {
  const { userId, customer, imageName } = body;
  try {
    const response = await apiRequest(
      `${api}/${userId}/${customer}/${imageName}`,
      "DELETE",
    );
    return response;
  } catch (err) {
    throw err;
  }
}
